import React, { useContext, useState } from "react";
import InputDropdown from "../../../CommonComponents/InputDropdown";
import InputField from "../../../CommonComponents/InputField";
import Textarea from "../../../CommonComponents/Textarea";
import { Editor } from "@tinymce/tinymce-react";
import Button from "../../../Button";
import { LibraryContext } from "../../../../context/LibraryContext";
import AlertContext from "../../../../context/AlertContext";
import TopicComplexity from "../TopicComplexity";
import { nanoid } from "nanoid";
import Tooltip from "../../../CommonComponents/Tooltip";
import { getDataFromStorage } from "../../../../util";

const QuestionForm = ({
  level,
  ccTopic,
  topics,
  selectedTopics,
  setSelectedTopics,
  testDetails,
  setTestDetails,
  errors,
  setErrors,
  isPublished,
  onChange,
}) => {
  const LibraryCxt = useContext(LibraryContext);
  const Alert = useContext(AlertContext);
  const onChangeField = (step, field, value) => {
    onChange && onChange(step, field, value);
  };
  const [count, setCount] = useState(0);
  console.log("testDetails :", testDetails);

  const addTopics = (e) => {
    e.preventDefault();
    const topicAndComplexity = selectedTopics;
    // console.log("errors.secName[0]", errors.secName);
    const section = testDetails.secName[0];

    const topicError = !section.topics ? "Topic is required" : "";
    const levelError = !section.level ? "Level is required" : "";

    // ❌ Block add if ANY is missing
    if (topicError || levelError) {
      setErrors((prev) => ({
        ...prev,
        0: {
          ...prev[0],
          secName: {
            topics: topicError,
            level: levelError,
          },
        },
      }));
      return;
    }
    const currSelectedTopic = topics.find(
      (topic) => topic.value === testDetails?.secName[0]?.topics,
    );
    const currSelectedComplexity = level.find(
      (l) => l.value === testDetails?.secName[0]?.level,
    );
    if (
      topicAndComplexity.some((item) => item.name === currSelectedTopic?.label)
    ) {
      Alert.setShowNotify({
        show: true,
        title: "Warning",
        msg: `Topic "${currSelectedTopic?.label}" already added!`,
      });
      return;
    }

    const newKey = count + 1;

    const newData = {
      // key: newKey,
      topicname: currSelectedTopic?.label,
      complexity: currSelectedComplexity?.label,
    };

    const topicData = {
      key: newKey,
      name: currSelectedTopic?.label,
      value: currSelectedTopic?.value,
      complexity: currSelectedComplexity?.value,
      complexityLabel: currSelectedComplexity?.label,
    };
    setCount(newKey);
    topicAndComplexity.push(topicData);
    // console.log("topicAndComplexity", topicAndComplexity);
    setSelectedTopics(topicAndComplexity);
    LibraryCxt.setTopicAndComplexity(topicAndComplexity);
    LibraryCxt.setDataTopicAndComplexity((prev) => [...prev, newData]);
    setTestDetails((prev) => ({
      ...prev,
      secName: prev.secName.map((item, idx) =>
        idx === 0 ? { ...item, topics: "", level: "" } : item,
      ),
    }));
  };

  // const deleteAddedTopicAndComplexity = (pos) => {
  //   setSelectedTopics((prevTopics) => {
  //     const updated = prevTopics.filter((_, index) => index !== pos);
  //     return updated;
  //   });
  // };

  const onAddTopicComp = (topicId, complexityId) => {
    const topic = topics.find((t) => t.value === topicId);
    const complexityLevel = level.find((c) => c.value === complexityId);

    if (!topic || !complexityLevel) return;
    const newTopicComplexity = {
      id: nanoid(),
      topicId: topic.value,
      topicName: topic.label,
      complexityId: complexityLevel.value,
      complexityName: complexityLevel.label,
    };

    LibraryCxt.setTopicAndComplexity((prev) => [...prev, newTopicComplexity]);

    setSelectedTopics((prev) => {
      const isAlreadyAdded = prev.some(
        (tc) =>
          tc.topicId === topic.value &&
          tc.complexityId === complexityLevel.value,
      );

      if (isAlreadyAdded) {
        // console.log("Topic and complexity already added");
        Alert.setShowNotify({
          show: true,
          title: "Warning",
          msg: `Topic "${topic?.label}" already added!`,
        });
        return prev;
      }

      return [...prev, newTopicComplexity];
    });

    setTestDetails((prev) => {
      const prevList = prev.topicComplexity ?? [];

      const isAlreadyAdded = prevList.some(
        (tc) =>
          tc.topicId === topic.value &&
          tc.complexityId === complexityLevel.value,
      );

      if (isAlreadyAdded) {
        return prev;
      }

      return {
        ...prev,
        topicComplexity: [...prevList, newTopicComplexity],
      };
    });
    setErrors((prev) => ({
      ...prev,
      0: {
        ...prev[0],
        topicComplexity: null,
      },
    }));
  };

  const onRemoveTopicComp = (id) => {
    console.log("Remove topic complexity", id);
    setSelectedTopics((prev) => prev.filter((tc) => tc.id !== id));
    setTestDetails((prev) => ({
      ...prev,
      topicComplexity: prev.topicComplexity.filter((tc) => tc.id !== id),
    }));
  };

  console.log("selected Topics:", selectedTopics);
  console.log("Frontend testdetails :", testDetails);
  return (
    <div className="questionform-main-container">

      <section className="questionform-question-1">

        <InputField
          label="Title"
          name="title"
          value={testDetails?.title ?? ""}
          placeholder="Enter the title here"
          onChange={(event) =>
            onChangeField(0, event.target.name, event.target.value)
          }
          hintText={errors?.title}
          destructive={!!errors?.title}
          disabled={isPublished}
        />

        <InputField
          label="Main Question"
          name="name"
          value={testDetails?.name ?? ""}
          placeholder="Enter the heading here"
          onChange={(event) =>
            onChangeField(0, event.target.name, event.target.value)
          }
          hintText={errors?.name}
          destructive={!!errors?.name}
          disabled={isPublished}
        />
      </section>
      <div className="questionform-question-2">
        <p className="questionform-question-2-title">Description</p>
        <Editor
          tinymceScriptSrc="/tinymce/tinymce.min.js"
          onEditorChange={(event) => onChangeField(0, "description", event)}
          value={testDetails?.description ?? ""}
          disabled={isPublished}
          // onInit={(evt, editor) => (editorRef.current = editor)}
          init={{
            license_key: "gpl",
            readonly: true,
            menubar: false,
            branding: false,
            statusbar: false,
            elementpath: false,
            selector: "textarea",
            allow_html_in_named_anchor: true,
            plugins: [
              "link",
              "help",
              "code",
              "lists",
              "image",
              "table",
              "media",
              "anchor",
              "editor",
              "advlist",
              "preview",
              "charmap",
              "wordcount",
              "fullscreen",
              "autoresize",
              "visualblocks",
              "searchreplace",
              "insertdatetime",
            ],
            toolbar:
              "undo redo | blocks | " +
              "bold italic underline forecolor | link | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | image | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | help |",

            content_style:
              "body { font-family:Inter,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>
      <div className="questionform-question-3">
        <p className="questionform-question-3-title">Answer Explanation</p>
        <Editor
          tinymceScriptSrc="/tinymce/tinymce.min.js"
          onEditorChange={(event) => onChangeField(0, "answer", event)}
          value={testDetails?.answer ?? ""}
          disabled={isPublished}
          // onInit={(evt, editor) => (editorRef.current = editor)}
          init={{
            license_key: "gpl",
            readonly: true,
            menubar: false,
            branding: false,
            statusbar: false,
            elementpath: false,
            selector: "textarea",
            allow_html_in_named_anchor: true,
            plugins: [
              "link",
              "help",
              "code",
              "lists",
              "image",
              "table",
              "media",
              "anchor",
              "editor",
              "advlist",
              "preview",
              "charmap",
              "wordcount",
              "fullscreen",
              "autoresize",
              "visualblocks",
              "searchreplace",
              "insertdatetime",
            ],
            toolbar:
              "undo redo | blocks | " +
              "bold italic underline forecolor | link | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | image | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | help |",

            content_style:
              "body { font-family:Inter,Arial,sans-serif; font-size:14px }",
          }}
        />
        {/* <h1 className={errors?.answer ? "error-text-answer":"error"}>{errors?.answer}</h1> */}
      </div>
      {
        getDataFromStorage("companyId") == 1 &&
        (<div style={{ display: "flex", gap: "24px", width: "800px" }}>
          <InputDropdown
            label="Link to Practice Coding Challenge"
            placeholder="Iterations"
            options={ccTopic}
            creatable
            hintText={errors?.ccSecName?.ccTopic}
            destructive={!!errors?.ccSecName?.ccTopic}
            value={testDetails?.ccTopic ?? []}
            name="ccTopic"
            onChange={(value) => onChangeField(0, "ccTopic", value)}
          />
          <InputDropdown
            label="Complexity"
            placeholder="Easy"
            options={level}
            creatable
            hintText={errors?.ccSecName?.ccLevel}
            destructive={!!errors?.ccSecName?.ccLevel}
            value={testDetails?.ccLevel ?? []}
            name="ccLevel"
            onChange={(value) => onChangeField(0, "ccLevel", value)}
          />
        </div>)
      }
      <section className="questionform-question-4">
        <div className="questionform-question-header">
          <div className="questionform-question-title">
            Select which topic and complexity this question belongs to:
          </div>
          <Tooltip title="This question can belong to more than one topic and complexity level.">
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.33333 12.6667V9.33333M9.33333 6H9.34167M17.6667 9.33333C17.6667 13.9357 13.9357 17.6667 9.33333 17.6667C4.73096 17.6667 1 13.9357 1 9.33333C1 4.73096 4.73096 1 9.33333 1C13.9357 1 17.6667 4.73096 17.6667 9.33333Z"
                stroke="#667085"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Tooltip>
        </div>
        <TopicComplexity
          onAddTopicComp={onAddTopicComp}
          topicOptions={topics}
          complexityOptions={level}
          topicComplexity={selectedTopics}
          onRemoveTopicComp={onRemoveTopicComp}
          errors={errors}
        />
      </section>
    </div>
  );
};

export default QuestionForm;
